import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiPackage, FiDollarSign } = FiIcons;

const Deliverables = () => {
  const deliverables = [
    {
      id: 1,
      name: "Documentary / Interview Film (10-15 min)",
      phases: "Phase A",
      scope: "1-day shoot • scripting • 2-day edit • audio polish",
      rate: "$5-6k norm",
      cost: "$5250"
    },
    {
      id: 2,
      name: "2-min Promo Reel",
      phases: "A, B",
      scope: "Re-cuts, motion supers, VO",
      rate: "1.5-2k",
      cost: "$1500"
    },
    {
      id: 3,
      name: "Vertical Reels Package (8 pcs)",
      phases: "A – E",
      scope: "No new shoot: edits & captions",
      rate: "$120-150 ea.",
      cost: "$1000"
    },
    {
      id: 4,
      name: "Digital Burst Campaign #1 (ads + content, 3wks)",
      phases: "B",
      scope: "10 statics • 6 micro-clips • comms mgmt",
      rate: "2-3k",
      cost: "$2200"
    },
    {
      id: 5,
      name: "Construction Webinar",
      phases: "B",
      scope: "Landing page • livestream • follow-up",
      rate: "1-1.5k",
      cost: "$1300"
    },
    {
      id: 6,
      name: "Eco-Farm Reels Shoot (4 clips)",
      phases: "B / C",
      scope: "Half-day farm b-roll + edits",
      rate: "1-1.2k",
      cost: "$1150"
    },
    {
      id: 7,
      name: "Major-Donor Dinner Branding & Recap",
      phases: "C",
      scope: "Menus, backdrop, photographer, 3-min recap",
      rate: "1.7-2k",
      cost: "$1750"
    },
    {
      id: 8,
      name: "Winter Gala Hybrid Event",
      phases: "D",
      scope: "Event branding • 2-cam stream • next-day recap",
      rate: "4.5-6k",
      cost: "$4700"
    },
    {
      id: 9,
      name: "Paid Retargeting Burst #2",
      phases: "E",
      scope: "Creative refresh • optimisation",
      rate: "1.5-2k",
      cost: "$1550"
    },
    {
      id: 10,
      name: "Impact Montage + 20-page Report",
      phases: "E",
      scope: "90-sec edit • designed PDF",
      rate: "2-2.5k",
      cost: "$2050"
    }
  ];

  const totalCost = deliverables.reduce((sum, item) => sum + parseInt(item.cost.replace('$', '')), 0);

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <SafeIcon icon={FiPackage} className="w-12 h-12 mx-auto text-[#FF5F1F] mb-4" />
          <h2 className="text-3xl font-bold text-black mb-4">Creatica Studio: Deliverables & Cost (Benchmark Pricing)</h2>
        </div>

        <div className="bg-white rounded-lg shadow-sm overflow-hidden border border-gray-200">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-black text-white">
                <tr>
                  <th className="px-4 py-4 text-left font-semibold">#</th>
                  <th className="px-4 py-4 text-left font-semibold">Deliverable / Campaign</th>
                  <th className="px-4 py-4 text-left font-semibold">When Used (phases)</th>
                  <th className="px-4 py-4 text-left font-semibold">High-Level Scope</th>
                  <th className="px-4 py-4 text-left font-semibold">Std Rate</th>
                  <th className="px-4 py-4 text-left font-semibold">Cost (CAD)</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {deliverables.map((item, index) => (
                  <tr key={item.id} className={index % 2 === 0 ? 'bg-gray-50' : 'bg-white'}>
                    <td className="px-4 py-4 text-center">
                      <span className="bg-[#FF5F1F] text-white rounded-full w-6 h-6 flex items-center justify-center text-sm font-bold">
                        {item.id}
                      </span>
                    </td>
                    <td className="px-4 py-4 text-gray-900 font-medium">{item.name}</td>
                    <td className="px-4 py-4 text-gray-700">{item.phases}</td>
                    <td className="px-4 py-4 text-gray-700">{item.scope}</td>
                    <td className="px-4 py-4 text-gray-700">{item.rate}</td>
                    <td className="px-4 py-4 text-gray-900 font-semibold">{item.cost}</td>
                  </tr>
                ))}
              </tbody>
              <tfoot className="bg-[#FF5F1F] text-white">
                <tr>
                  <td colSpan="5" className="px-4 py-4 text-right font-bold text-lg">Total Investment:</td>
                  <td className="px-4 py-4 font-bold text-xl">${totalCost.toLocaleString()}</td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>

        <div className="mt-8 bg-yellow-50 border border-yellow-200 rounded-lg p-6">
          <p className="text-sm text-gray-700 italic">
            A separate paid media budget equivalent to approximately 8%-12% of the overall campaign service total is recommended to support digital reach, awareness, and conversion efforts. 
            This budget is not included in Creatica Studio Inc.'s service fees and will be managed independently in coordination with the Foundation.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Deliverables;